// extracted by mini-css-extract-plugin
export default {"filterLight":"ImageButton_filterLight__PoKfv","filterDark":"ImageButton_filterDark__xmQpS","imageButton":"ImageButton_imageButton__NFMml","tooltip":"ImageButton_tooltip__nKC1p"};